import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { get, post, put } from '../../axios/apiService';
import React, { useMemo } from 'react';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useEffect } from 'react';
import axios from 'axios';
import LoadingBackdrop from 'ui-component/full-screen-loadder/LoadingBackdrop';
import DocumentUploader from 'ui-component/uploadDocument';
import { getFileNameFromUrl } from 'utils/urlToGetFileName';
import { useNavigate } from 'react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { addPercentage, isEmpty, isValidDate, isValidPhoneNumber, validateAmount, validateEmail, validateMaxLength } from 'utils/validator';
import uploadFilesService from '../../axios/uploadFilesService';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import parsePhoneNumberFromString from 'libphonenumber-js';
import { Stack, styled } from '@mui/system';
import NomineeDetails from 'ui-component/nomineeDetail';
import { generateUniqueId } from 'utils/commonfunction';

const ResizableTextField = styled(TextField)({
  '& .MuiInputBase-inputMultiline': {
    resize: 'both',
    overflow: 'auto',
  },
});

const PremiumFrequencyOptions = [
  { value: 1, label: "Monthly" },
  { value: 2, label: "Quarterly" },
  { value: 3, label: "HalfYearly" },
  { value: 4, label: "Yearly" },
];

function AddEditInsuranceForm({ id, setIsShowForm, customerId }) {
  console.log('id', id);

  const [typeValues, setTypeValues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [usedInsuranceNominees, setUsedInsuranceNominees] = useState([]);
  const [isValidationNominee, setIsValidationNominee] = useState(false);

  const {
    control: nomineesControl,
    getValues: nomineesGetValues,
    reset: nomineesReset,
    watch: nomineesWatch
  } = useForm({
    defaultValues: {
      address: "",
      firstName: "",
      lastName: "",
      phone: "",
    },
  });
  const { control, handleSubmit, reset, getValues, watch } = useForm({
    defaultValues: {
      insuranceId: '',
      policy: '',
      company: '',
      type: 0,
      insuredName: '',
      policyNumber: '',
      insuredAmount: '',
      premium: '',
      sumAssured: '',
      bonusAssured: '',
      cashValue: '',
      maturityDate: '',
      regEmail: '',
      nomineeId: '',
      firstName: '',
      lastName: '',
      phone: '',
      address: '',
      premiumFrequency: 0,
      insuranceDocuments: null
    }
  });

  const [documentList, setDocumentList] = useState([]);
  const [existingDoc, setExistingDoc] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isValidation, setIsValidation] = useState(false);

  const watchedFields = [
    'policy',
    'company',
    'type',
    'policyNumber',
    'insuredName',
    'insuredAmount',
    'premium',
    'sumAssured',
    'bonusAssured',
    'cashValue',
    'maturityDate',
    'regEmail',
    'nomineeId',
    'firstName',
    'lastName',
    'phone',
    'address',
    'insuranceDocuments',
  ];

  const formValues = useMemo(() =>
    watchedFields.reduce((acc, field) => {
      acc[field] = watch(field);
      return acc;
    }, {}),
    watchedFields.map(watch)
  );

  useEffect(() => {
    if (isValidation) {
      validator(formValues);
    }
  }, [formValues, isValidation]);

  useEffect(() => {
    if (isValidationNominee) {
      const formNomineesData = {
        firstName: nomineesWatch("firstName"),
        lastName: nomineesWatch("lastName"),
        address: nomineesWatch("address"),
        phone: nomineesWatch("phone"),
        allocationPercentage: nomineesWatch("allocationPercentage"),
      };
      validateNominees(formNomineesData);
    }
  }, [isValidationNominee, nomineesWatch("firstName"), nomineesWatch("lastName"), nomineesWatch("address"), nomineesWatch("phone"), nomineesWatch("allocationPercentage")]);


  useEffect(() => {
    const fetchTypes = async () => {
      try {
        let response = await get(`WillTypeMaster/Insurance`);
        setTypeValues(response);
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchTypes();

    if (id) {
      const getByIdInsurance = async () => {
        setIsLoading(true);
        try {
          let response = await get(`Insurance/getAllDetailByInsurance/${id}`, null);
          if (response != null) {
            const statusValue = premiumFrequencyGetByValue(response.premiumFrequency) || undefined;
            reset({
              insuranceId: response?.id || '',
              policy: response?.policy || '',
              company: response.company || '',
              type: response.type || '',
              policyNumber: response.policyNumber || '',
              insuredName: response.insuredName || '',
              insuredAmount: response.insuredAmount || '',
              premium: response.premium || '',
              sumAssured: response.sumAssured || '',
              bonusAssured: response.bonusAssured || '',
              cashValue: response.cashValue || '',
              maturityDate: formatDate(response.maturityDate) || '',
              regEmail: response.regEmail || '',
              nomineeId: response.insuranceNominees.id || '',
              firstName: response.insuranceNominees.firstName || '',
              lastName: response.insuranceNominees.lastName || '',
              phone: response.insuranceNominees.phone || '',
              address: response.insuranceNominees.address || '',
              insuranceDocuments: response.insuranceDocuments,
              premiumFrequency: statusValue.value,
            });
            // let existDocList = response.insuranceDocuments?.map(x => {
            //   let fileName = getFileNameFromUrl(x.blobUrl);
            //   return { ...x, fileName }
            // })
            setExistingDoc(response.insuranceDocuments);
            setUsedInsuranceNominees(response.insuranceNominees);
          }
        } catch (err) {
          console.error(err?.message);
        } finally {
          setIsLoading(false);
        }
      };
      getByIdInsurance();
    }
  }, [id]);

  const premiumFrequencyGetByValue = (statusValue) => {
    return (
      PremiumFrequencyOptions.find(
        (option) => option.label?.replace(" ", "")?.toUpperCase() == statusValue?.toUpperCase()
      ) || undefined
    );
  };

  const onSubmit = async (data) => {
    setIsValidation(true);
    if (!validator()) return;
    let uploadFileList = await uploadDocBlob();
    let insuranceDocuments =
      uploadFileList?.map((x) => ({
        blobUrl: x.fileName,
        fileName: documentList[x.fileId - 1].name
      })) || [];

    // if (!id && insuranceDocuments.length === 0) {
    //   toast.error('please upload document');
    //   return;
    // }

    if (!customerId) {
      toast.error('Please select customer');
      return;
    }

    if (usedInsuranceNominees.length == 0) {
      toast.error("Please add at least one nominee");
      return;
    }
    let allocationTotal = 0;
    usedInsuranceNominees.forEach((x) => (allocationTotal += parseFloat(x.allocationPercentage.toString())));
    if (allocationTotal != 100) {
      toast.error("Allocation of all nominee(s) must be 100%");
      return;
    }

    const apiUrl = id ? `Insurance/${id}` : 'Insurance';
    let param = {
      insurance: {
        customerId: customerId,
        policy: data.policy,
        company: data.company,
        type: data.type,
        policyNumber: data.policyNumber,
        insuredName: data.insuredName,
        insuredAmount: parseInt(data.insuredAmount) ?? 0,
        premium: parseInt(data.premium) ?? 0,
        sumAssured: parseInt(data.sumAssured) ?? 0,
        bonusAssured: parseInt(data.bonusAssured) ?? 0,
        cashValue: parseInt(data.cashValue) ?? 0,
        maturityDate: data.maturityDate,
        regEmail: data.regEmail,
        premiumFrequency: PremiumFrequencyOptions.find(x => x.value == data.premiumFrequency).label,
      },
      insuranceDocuments,
      // insuranceNominees: [{
      //   firstName: data.firstName,
      //   lastName: data.lastName,
      //   phone: data.phone,
      //   address: data.address
      // }]
      insuranceNominees: usedInsuranceNominees,
    };

    if (id) {
      param.insurance.id = id;
      // param.insuranceNominees.id = data.nomineeId;
      // param.insuranceNominees.insuranceId = id;
      // let existingFileName = existingDoc.map(x => { return { blobUrl: x.fileName } });
      let existingFileName = existingDoc?.map((x) => {
        let urlName = getFileNameFromUrl(x.blobUrl);
        return { ...x, blobUrl: urlName };
      });

      param.insuranceDocuments = [...insuranceDocuments, ...existingFileName];

      // if (param?.insuranceDocuments?.length === 0) {
      //   toast.error('please upload document');
      //   return;
      // }
    }
    try {
      setIsLoading(true);
      let response = id ? await put(apiUrl, param) : await post(apiUrl, param);
      if (response) {
        toast.success(id ? 'Insurance updated successfully' : 'Insurance added successfully');
      }
      navigate('/will-management');
    } catch (error) {
      toast.error("Failed to save insurance. Please try again.");
    } finally {
      setIsLoading(false);
    }
    setIsValidation(false);

    setIsShowForm(false);
  };

  const uploadDocBlob = async (data) => {
    const formData = new FormData();
    for (let i = 0; i < documentList.length; i++) {
      formData.append('files', documentList[i]);
      formData.append('fileIds', i + 1);
    }
    formData.append('categoryId', 1);
    try {
      let data = await uploadFilesService(formData);
      return data;
    } catch (error) {
      console.error('There was an error uploading the files!', error);
    }
  };

  const handleUpload = (newFiles) => {
    setDocumentList((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleRemove = (index) => {
    setDocumentList((prevDocuments) => prevDocuments.filter((_, i) => i !== index));
  };
  const handleRemoveExistDoc = (index) => {
    setExistingDoc((prevDocuments) => prevDocuments.filter((_, i) => i !== index));
  };

  const validator = () => {
    let data = getValues();
    const errors = {};
    if (isEmpty(data?.policy)) {
      errors.policy = 'Please Enter Policy';
    }

    if (!validateAmount(data?.type, 1)) {
      errors.type = "Please select type";
    }

    if (!validateMaxLength(data?.policy, 100)) {
      errors.policy = ` The value exceeds the maximum allowed length of ${100} characters.`;
    }

    if (isEmpty(data?.company)) {
      errors.company = 'Please enter Company name';
    }

    if (!validateMaxLength(data?.company, 100)) {
      errors.company = ` The value exceeds the maximum allowed length of ${100} characters.`;
    }

    if (isEmpty(data?.policyNumber)) {
      errors.policyNumber = 'Please Enter PolicyNumber';
    }


    if (!validateMaxLength(data?.policyNumber, 50)) {
      errors.policyNumber = ` The value exceeds the maximum allowed length of ${50} characters.`;
    }

    if (isEmpty(data?.insuredName)) {
      errors.insuredName = 'Please Enter InsuredName';
    }
    if (!validateMaxLength(data?.insuredName, 50)) {
      errors.insuredName = ` The value exceeds the maximum allowed length of ${30} characters.`;
    }

    if (!validateAmount(data?.insuredAmount, 1)) {
      errors.insuredAmount = "Please enter a valid insuredAmount greater than or equal to 1.";
    }

    if (!validateAmount(data?.premium, 1)) {
      errors.premium = "Please enter a valid Premium greater than or equal to 1.";
    }

    if (!validateAmount(data?.sumAssured, 1)) {
      errors.sumAssured = "Please enter a valid SumAssured greater than or equal to 1.";
    }

    if (!validateAmount(data?.bonusAssured, 1)) {
      errors.bonusAssured = "Please enter a valid BonusAssured greater than or equal to 1.";
    }

    if (!validateAmount(data?.cashValue, 1)) {
      errors.cashValue = "Please enter a valid CashValue greater than or equal to 1.";
    }

    if (!isValidDate(data?.maturityDate)) {
      errors.maturityDate = 'Please Enter MaturityDate';
    }

    if (isEmpty(data?.regEmail)) {
      errors.regEmail = 'Please Enter email-id';
    } else if (!isEmpty(data?.regEmail) && !validateEmail(data.regEmail)) {
      errors.regEmail = 'Please Enter a valid email';
    } else {
      delete errors.regEmail;
    }



    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateNominees = (nomineesData) => {
    const errors = {};

    if (isEmpty(nomineesData?.firstName)) {
      errors.firstName = "Please Enter First Name";
    }

    if (isEmpty(nomineesData?.lastName)) {
      errors.lastName = "Please Enter Last Name";
    }

    let mobileNumber = nomineesData?.phone && nomineesData?.phone.startsWith('+') ? nomineesData?.phone : `+${nomineesData?.phone}`;
    let phoneNumber = parsePhoneNumberFromString(mobileNumber);

    if (!phoneNumber || !phoneNumber.isValid()) {
      errors.phone = "Invalid Phone Number";
    }

    if (isEmpty(nomineesData?.address)) {
      errors.address = "Please Enter Address";
    }

    if (!validateAmount(nomineesData?.allocationPercentage, 1)) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage greater than or equal to 1.";
    }
    if (!isNaN(nomineesData?.allocationPercentage) && nomineesData?.allocationPercentage > 100) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    }
    if (!isNaN(nomineesData?.allocationPercentage) && !addPercentage(nomineesData?.allocationPercentage, usedInsuranceNominees)) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const saveNominees = () => {
    let nomineesData = {
      firstName: nomineesGetValues("firstName"),
      lastName: nomineesGetValues("lastName"),
      address: nomineesGetValues("address"),
      phone: nomineesGetValues("phone"),
      id: generateUniqueId(),
      allocationPercentage: nomineesGetValues("allocationPercentage"),
    };
    setIsValidationNominee(true);
    if (!validateNominees(nomineesData)) return;
    setIsValidationNominee(false);

    try {
      setIsLoading(true);
      let newNominees = usedInsuranceNominees;
      newNominees = [...newNominees, ...[nomineesData]];
      setUsedInsuranceNominees(newNominees);
      nomineesReset({
        address: "",
        firstName: "",
        id: "",
        lastName: "",
        phone: "",
        allocationPercentage: 0,
      });
    } catch (error) {
      console.log("error....", error)
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setIsShowForm(false);
  };

  const handlePhoneChange = (value) => {
    console.log(value); // Log the new phone number
    setCustomer((prevCustomer) => ({
      ...prevCustomer,
      mobileNumber: value, // Update the mobileNumber
    }));
  };

  const columns = [
    { field: "firstName", headerName: "First Name", flex: 1 },
    { field: "lastName", headerName: "Last Name", flex: 1 },
    { field: "phone", headerName: "Phone Number", flex: 1 },
    { field: "address", headerName: "Address", flex: 1 },
    { field: "allocationPercentage", headerName: "Allocation Percentage", flex: 1 },
    {
      field: "action",
      headerName: "Actions",
      renderCell: (params) => <ActionButtons {...params.row} />,
      // align: 'right',
      width: 200,
      sortable: false,
      filterable: false,
    },
  ];

  const ActionButtons = (row) => {
    return (
      <Stack
        direction={"row"}
        spacing={1}
        justifyContent="center"
        sx={{ marginTop: "10px" }}
      >
        <Button
          color="primary"
          size="small"
          variant="contained"
          onClick={() => {
            handleNomineeEdit(row.id);
          }}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => {
            setUsedInsuranceNominees((prevItems) => prevItems.filter((item) => item.id != row.id));
          }}
        >
          Delete
        </Button>
      </Stack>
    );
  };


  const handleNomineeEdit = (nomineeId) => {
    let existingNominee = usedInsuranceNominees.filter((x) => x.id == nomineeId);
    const updatedNominees = usedInsuranceNominees.filter((nominee) => nominee.id !== nomineeId);
    setUsedInsuranceNominees(updatedNominees);
    if (existingNominee && existingNominee[0]) {
      nomineesReset({
        address: existingNominee[0].address,
        allocationPercentage: existingNominee[0].allocationPercentage,
        firstName: existingNominee[0].firstName,
        lastName: existingNominee[0].lastName,
        phone: existingNominee[0].phone,
        id: existingNominee[0].id,
      });
    }
  };
  return (
    // <MainCard title="Insurance Form">
    <>
      <Box sx={{ padding: '30px 0' }}>
        {/* <Typography variant="h3">Insurance Form</Typography> */}
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={() => setIsShowForm(false)} startIcon={<ArrowBackIcon />}>
              Back
            </Button>
          </Box>
        </Grid>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid item xs={12}>
            <fieldset style={styles.fieldset}>
              <legend style={styles.legend}>Insurance Information</legend>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Controller name="policy" control={control} render={({ field }) => <TextField {...field} label="Policy" />} />
                    <div style={{ color: 'red' }}>{formErrors.policy}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Controller name="company" control={control} render={({ field }) => <TextField {...field} label="Company" />} />
                    <div style={{ color: 'red' }}>{formErrors.company}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <InputLabel id="type-label">Type</InputLabel>
                    <Controller
                      name="type"
                      control={control}
                      render={({ field }) => (
                        <>
                          <Select labelId="type-label" label="Type" {...field}>
                            {typeValues &&
                              typeValues.map((x, i) => (
                                <MenuItem value={x.id} key={i}>
                                  {x.name}
                                </MenuItem>
                              ))}
                          </Select>
                        </>
                      )}
                    />
                    <div style={{ color: 'red' }}>{formErrors.type}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Controller name="insuredName" control={control} render={({ field }) => <TextField {...field} label="InsuredName" />} />
                    <div style={{ color: 'red' }}>{formErrors.insuredName}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Controller
                      name="policyNumber"
                      control={control}
                      render={({ field }) => <TextField {...field} label="PolicyNumber" />}
                    />
                    <div style={{ color: 'red' }}>{formErrors.policyNumber}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Controller name="insuredAmount" control={control} render={({ field }) => <TextField {...field} label="InsuredAmount" type='number' />} />
                    <div style={{ color: 'red' }}>{formErrors.insuredAmount}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Controller
                      name="premium"
                      control={control}
                      render={({ field }) => <TextField {...field} type="number" label="Premium" />}
                    />
                    <div style={{ color: 'red' }}>{formErrors.premium}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <InputLabel id="type-label">PremiumFrequency</InputLabel>
                    <Controller
                      name="premiumFrequency"
                      control={control}
                      render={({ field }) => (
                        <>
                          <Select labelId="type-label" label="Type" {...field}>
                            {PremiumFrequencyOptions &&
                              PremiumFrequencyOptions.map((x, i) => (
                                <MenuItem value={x.value} key={i}>
                                  {x.label}
                                </MenuItem>
                              ))}
                          </Select>
                        </>
                      )}
                    />
                    <div style={{ color: 'red' }}>{formErrors.premiumFrequency}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Controller
                      name="sumAssured"
                      control={control}
                      render={({ field }) => <TextField {...field} type="number" label="SumAssured" />}
                    />
                    <div style={{ color: 'red' }}>{formErrors.sumAssured}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Controller
                      name="bonusAssured"
                      control={control}
                      render={({ field }) => <TextField {...field} type="number" label="BonusAssured" />}
                    />
                    <div style={{ color: 'red' }}>{formErrors.bonusAssured}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Controller
                      name="cashValue"
                      control={control}
                      render={({ field }) => <TextField {...field} type="number" label="CashValue" />}
                    />
                    <div style={{ color: 'red' }}>{formErrors.cashValue}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Controller
                      name="maturityDate"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          id="maturity-date"
                          InputLabelProps={{
                            shrink: true
                          }}
                          fullWidth
                          {...field}
                          type="date"
                          label="MaturityDate"
                        />
                      )}
                    />
                    <div style={{ color: 'red' }}>{formErrors.maturityDate}</div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Controller
                      name="regEmail"
                      control={control}
                      render={({ field }) => <TextField {...field} type="email" label="RegEmail" />}
                    />
                    <div style={{ color: 'red' }}>{formErrors.regEmail}</div>
                  </FormControl>
                </Grid>
              </Grid>
            </fieldset>
          </Grid>
          <fieldset style={{ ...styles.fieldset, marginTop: '10px' }}>
            <legend style={styles.legend}>Document Information</legend>
            <DocumentUploader
              onUpload={handleUpload}
              documentList={documentList}
              onRemove={handleRemove}
              onRemoveExistDoc={handleRemoveExistDoc}
              existDocumentList={existingDoc}
            />
          </fieldset>
          <fieldset style={{ ...styles.fieldset, marginTop: '10px' }}>
            <legend style={styles.legend}>Nominee Information</legend>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="firstName" control={nomineesControl} render={({ field }) => <TextField {...field} label="First Name" />} />
                  <div style={{ color: 'red' }}>{formErrors.firstName}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="lastName" control={nomineesControl} render={({ field }) => <TextField {...field} label="Last Name" />} />
                  <div style={{ color: 'red' }}>{formErrors.lastName}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="phone" control={nomineesControl} render={({ field }) =>
                    <PhoneInput
                      {...field}
                      country={'in'}
                      onChange={(value) => field.onChange(value)}
                      inputStyle={{ width: '100%' }}
                    />

                  } />

                  <div style={{ color: 'red' }}>{formErrors.phone}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="address" control={nomineesControl} render={({ field }) =>
                    <ResizableTextField
                      {...field}
                      label="Address"
                      multiline
                      rows={4} // Specifies initial number of rows
                    />
                  } />
                  <div style={{ color: 'red' }}>{formErrors.address}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="allocationPercentage"
                    control={nomineesControl}
                    render={({ field }) => <TextField {...field} label="AllocationPercentage" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.allocationPercentage}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    style={{ marginRight: "10px" }}
                    onClick={saveNominees}
                  >
                    Save Nominee
                  </Button>
                </Box>
              </Grid>
              {usedInsuranceNominees && usedInsuranceNominees.length > 0 && (
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: '10px' }}>
                  <NomineeDetails nominees={usedInsuranceNominees} columns={columns} />
                </Grid>
              )}
            </Grid>
          </fieldset>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: '10px' }}>
            <Button type="submit" variant="contained" color="primary" className="mt-4" style={{ marginRight: '15px' }}>
              Submit
            </Button>
            <Button
              type="button"
              variant="contained"
              color="error"
              className="mt-4"
              onClick={() => {
                setIsShowForm(false);
              }}
            >
              Cancel
            </Button>
          </Grid>
        </form>
      </Box>
      <LoadingBackdrop open={isLoading} />
    </>
    // </MainCard>
  );
}

export default AddEditInsuranceForm;
const styles = {
  fieldset: {
    border: '1px solid #364152',
    borderRadius: '8px',
    padding: '20px'
  },
  legend: {
    color: '#364152',
    padding: '0 10px',
    fontSize: '18px'
  }
};

const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const year = date.getFullYear();
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  return `${year}-${month}-${day}`;
};
